import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from './translate-loader.service';
import { AppConfigService } from '@anecdotes/configuration-data-access';

@NgModule({
  declarations: [],
  exports: [TranslateModule],
  imports: [CommonModule, TranslateModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class TranslateConfigModule {
  constructor(configService: AppConfigService, translateService: TranslateService) {
    const defaultLangFromConfig = configService.config.internationalization.defaultLanguage;
    const defaultResolvedLang = defaultLangFromConfig ? defaultLangFromConfig : 'en-US';
    translateService.setDefaultLang(defaultResolvedLang);
    translateService.use(defaultResolvedLang);
  }

  static forRoot(): ModuleWithProviders<TranslateConfigModule> {
    return {
      ngModule: TranslateConfigModule,
      providers: [
        ...TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useClass: TranslateHttpLoader,
          },
          useDefaultLang: true,
          defaultLanguage: 'en-US',
        }).providers,
      ],
    };
  }
}
